import { Injectable, signal, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NavigationFeedbackService {

  private readonly snackBar = inject(MatSnackBar);

  readonly fallbackMessage = signal<string | null>(null);

  notify(message: string): void {
    try {
      this.snackBar.open(message, 'Dismiss', {
        duration: 4000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: ['nav-feedback-snack']
      });
      this.fallbackMessage.set(null);
    } catch {
      this.fallbackMessage.set(message);
    }
  }
}
